import { render, staticRenderFns } from "./tenderSultation.vue?vue&type=template&id=5583b774&scoped=true&"
import script from "./tenderSultation.vue?vue&type=script&lang=js&"
export * from "./tenderSultation.vue?vue&type=script&lang=js&"
import style0 from "./tenderSultation.vue?vue&type=style&index=0&id=5583b774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583b774",
  null
  
)

export default component.exports